// Print
function pr(str) {
    console.log('log : ',str)
}

export default pr;
